'use strict';

var React = require('react');

var SvgColumns2Major = function SvgColumns2Major(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3 6a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3v-8Zm7.75-1.5h3.25a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-3.25v-11Zm-1.5 0h-3.25a1.5 1.5 0 0 0-1.5 1.5v8a1.5 1.5 0 0 0 1.5 1.5h3.25v-11Z"
  }));
};
SvgColumns2Major.displayName = "Columns2Major";

exports.SvgColumns2Major = SvgColumns2Major;
